import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MinExposureValidator extends BaseValidator {
    private errorMessage: string = 'Your total MIN EXP exceeds the 100% limit.';
    protected runValidation(): void {
        if (!this.isThereCheckedCombinationWithExposure()) {
            return;
        }

        // @ts-ignore
        const {stacking} = this.dependencies;

        const firstStackMinExpValue = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(1);

        if (firstStackMinExpValue > 100) {
            this.addError(this.errorMessage);
            return;
        }

        const secondStackMinExpValue = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(2);

        if (secondStackMinExpValue > 100) {
            this.addError(this.errorMessage);
        }
    }

    private isThereCheckedCombinationWithExposure(): boolean {
        // @ts-ignore
        const {stacking} = this.dependencies;

        const checkedCombinations = Object.values(stacking.getCheckedCombinations());

        for (let combo of checkedCombinations) {
            // @ts-ignore
            if (Number(combo.exposure) > 0) {
                return true;
            }
        }

        return false;
    }
}

export default MinExposureValidator;
